const React = require("react");
const T = React.PropTypes;

require("./DiskButton.less");

const DiskButton = React.createClass({
    propTypes: {
        className: T.string,
        onClick: T.func,
        MarkClassName: T.string
    },
    render() {
        const className = this.props.className + " cs-DiskButton";

        return (<button className={className} onClick={this.props.onClick}>
            <span className={this.props.MarkClassName}></span>
        </button>);
    }
});

module.exports = DiskButton;


// WEBPACK FOOTER //
// ./src/components/DiskButton/DiskButton.jsx